import React from "react";
import { useDrop } from "react-dnd";
import { generateDropSpec } from "../../utils/DnDUtils";
import { ASSET_ITEM } from "../../constants/DnDConstants";
import { galleryAssetListContainerDrop } from "./AssetDropHandlers";

const expandedStyle = {
  display: "flex",
  flexFlow: "row wrap",
  alignContent: "flex-start",
  flex: "1 1 auto",
};

const unexpandedStyle = { flex: "1", overflowY: "auto" };

const GalleryAssetListContainer = ({ expanded = false, children, galleryEditEnabled = false }) => {
  const drop = generateDropSpec({
    type: ASSET_ITEM,
    onDrop: (dragItem, monitor) => {
      // Only accept the drop if we're actually hovering over this container AND gallery edit is enabled
      if (monitor.isOver({ shallow: true }) && galleryEditEnabled) {
        return galleryAssetListContainerDrop(dragItem);
      }
      return null;
    },
  });

  const [{ isOver }, dropRef] = useDrop(drop);

  const listStyle = {
    padding: "8px",
    ...(expanded ? expandedStyle : unexpandedStyle),
  };

  return (
    <div title="gallery asset list" style={listStyle} ref={dropRef}>
      {children}
    </div>
  );
};

export default GalleryAssetListContainer;
